import { useState, createContext, useContext } from "react";
import BookingModal from "@/components/landing/BookingModal";

const BookingContext = createContext({ open: () => {}, openWith: () => {} });

export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [intent, setIntent] = useState("book"); // 'book' | 'workspace'

  const open = () => {
    setIntent("book");
    setIsOpen(true);
  };
  const openWith = (i) => {
    setIntent(i);
    setIsOpen(true);
  };

  return (
    <BookingContext.Provider value={{ open, openWith }}>
      {children}
      <BookingModal
        open={isOpen}
        onOpenChange={setIsOpen}
        intent={intent}
      />
    </BookingContext.Provider>
  );
};
